import { Segment } from './controls';

export const rangeOptions = [['7', '近 7 天'], ['30', '近 30 天'], ['90', '近 90 天'], ['all', '全部']] as const;
export const rangeValues: readonly string[] = rangeOptions.map(([value]) => value);

export function TimeRange({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  return <Segment label="时间范围" value={value} options={rangeOptions} onChange={onChange}/>;
}
